/**
 * Get a cookie value by name
 * @param {string} name - The name of the cookie to retrieve
 * @returns {string} - The cookie value or empty string if not found
 */
export const getCookie = (name) => {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) {
		return parts.pop().split(';').shift();
	}
	return '';
};

/**
 * Set a cookie value by name. Mirrors the format already used by
 * ws-locations-proximity (path=/) so all widgets read the same cookie.
 * Adds `SameSite=Lax` to mitigate CSRF exposure and `Secure` so the cookie
 * is only sent over HTTPS.
 * @param {string} name - The name of the cookie to write
 * @param {string} value - The value to store (will be URL-encoded)
 */
export const setCookie = (name, value) => {
	if (typeof document === 'undefined') {
		return;
	}
	document.cookie = `${name}=${encodeURIComponent(
		value
	)}; path=/; SameSite=Lax; Secure`;
};
